import styled from "styled-components/macro";
import { device } from "../../../device";

export const StyledPasswordReset = styled.div`
	margin-top: 1rem;
`;

export const StyledContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	grid-template-rows: minmax(400px, 1fr);
	border-radius: 4px;
	text-align: left;
	@media ${device.tablet} {
		grid-template-columns: 1fr;
	}
`;

export const NotificationContainer = styled.div`
	background: #f2f8f5;
	border: 1px solid #008060;
	position: relative;
	overflow: hidden;
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	text-align: left;
	padding: 24px;
	width: 100%;
	border-radius: 8px;
`;
